import Routes from '../../components/Routes';
import TaxAdvisorLayout from './TaxAdvisorLayout';
import { IRoute } from '../../core/types';
import { TaxAdvisorRoutesEnum } from '../../core/enums';
import Proforma from './Proforma/Proforma';
import { TaxAdvisorWrapper } from './tax-advisor-context';
import InvoiceBook from './InvoiceBook/InvoiceBook';
import ClientProfile from './ClientProfile/ClientProfile';
import TaxAdvisorDatev from './TaxAdvisorDatev/TaxAdvisorDatev';
import TaxAdvisorDatevConfiguration from './TaxAdvisorDatevConfiguration/TaxAdvisorDatevConfiguration';

export default function TaxAdvisorRoutes() {
  const routes: IRoute[] = [
    {
      path: '/',
      component: ClientProfile,
      exact: true,
    },
    {
      path: TaxAdvisorRoutesEnum.DATEV,
      component: TaxAdvisorDatev,
    },
    {
      path: TaxAdvisorRoutesEnum.DATEVConfiguration,
      component: TaxAdvisorDatevConfiguration,
    },
    {
      path: TaxAdvisorRoutesEnum.Proforma,
      component: Proforma,
    },
    {
      path: TaxAdvisorRoutesEnum.InvoiceBook,
      component: InvoiceBook,
    },
  ];

  return (
    <>
      <TaxAdvisorWrapper>
        <TaxAdvisorLayout>
          <Routes routes={routes} />
        </TaxAdvisorLayout>
      </TaxAdvisorWrapper>
    </>
  );
}
